import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=2f4e0c68&scoped=true&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"
import style0 from "./Unit.vue?vue&type=style&index=0&id=2f4e0c68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4e0c68",
  null
  
)

export default component.exports